"use client"

export const isKlaviyoIdSubscribed = async (id: string): Promise<boolean> => {
    try {
        const response = await fetch(
            `/api/klaviyo/klaviyo-is-klaviyo-id-subscribed?id=${id}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            }
        )

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        return data.subscribed || false
    } catch (error) {
        console.error("Error checking Klaviyo subscription status:", error)
        return false
    }
}

export default isKlaviyoIdSubscribed
